<template>
  <div class="search-page container-fluid search-container masthead">
    <section class="row">
      <!-- Filters Column -->
      <article class="col-md-3 search-filter-column mt-5">
        <section class="search-filter-section">
          <div class="search-filter-dropdown" @click="showFilterMenu(0)">
            <label class="search-label-title">Country</label>
            <div class="d-block d-lg-none">
              <img src="@/assets/imgs/svgs/arrow-down.svg" alt="" />
            </div>
          </div>
          <article v-if="filtersOpen[0]">
            <CustomCheckbox v-for="country in getCountriesAndCities" :title="country.country_name"
              :id="country.country_id" :checked="filters.country_ids.includes(country.country_id)"
              :item_ids="filters.city_ids" :key="'country_' + country.country_id" :items="country.cities"
              @checkbox-click="countrySelected" @sub-checkbox-click="citySelected" />
          </article>
        </section>

        <section class="search-filter-section">
          <div class="search-filter-dropdown" @click="showFilterMenu(2)">
            <label class="search-label-title">Discipline</label>
            <div class="d-block d-lg-none">
              <img src="@/assets/imgs/svgs/arrow-down.svg" alt="" />
            </div>
          </div>

          <article v-if="filtersOpen[2]">
            <CustomCheckbox v-for="course_category in getCourseCategories" :title="course_category.course_category_name"
              :id="course_category.course_category_id" :checked="filters.course_category_ids.includes(
                course_category.course_category_id
              )
                " :key="'course_category_' + course_category.course_category_id"
              @checkbox-click="courseCategorySelected" />
          </article>
        </section>

        <section class="search-filter-section">
          <div class="search-filter-dropdown d-flex justify-content-between align-items-center" @click="() => {
              showFilterMenu(3);
              clearTuitionFee();
            }
            ">
            <label class="search-label-title">Tuition Fees</label>
            <b-form-group v-slot="{ ariaDescribedby }" style="margin: 10px">
              <b-form-radio v-model="fee_currency" :aria-describedby="ariaDescribedby" name="fee-radios" value="INR"
                style="margin-bottom: 5px">INR</b-form-radio>
              <b-form-radio v-model="fee_currency" :aria-describedby="ariaDescribedby" name="fee-radios"
                value="USD">USD</b-form-radio>
            </b-form-group>
            <!-- <b-form-group v-slot="{ ariaDescribedby }" style="margin: 10px">
            <b-form-radio
            v-model="fee_currency"
            :aria-describedby="ariaDescribedby"
            name="fee-radios"
                value="INR"
                class="custom-radio"
                style="margin-bottom: 5px"
                >INR</b-form-radio
                >
              <b-form-radio
                v-model="fee_currency"
                :aria-describedby="ariaDescribedby"
                name="fee-radios"
                value="USD"
                class="custom-radio"
                >USD</b-form-radio
              >
            </b-form-group> -->
            <!-- <div class="">
              <div class="radio-box ">
                <input
                  type="radio"
                  name="fee-radios"
                  id="inr-radio"
                  value="INR"
                  v-model="fee_currency"
                  class="custom-radio"
                />
                <label for="inr-radio" class="custom-label">INR</label>
              </div>
              <div class="radio-box">
                <input
                type="radio"
                  name="fee-radios"
                  id="usd-radio"
                  value="USD"
                  v-model="fee_currency"
                  class="custom-radio"
                />
                <label for="usd-radio" class="custom-label">USD</label>
              </div>
            </div> -->
          </div>

          <div class="d-block d-lg-none">
            <img src="@/assets/imgs/svgs/arrow-down.svg" alt="" />
          </div>
          <article v-if="filtersOpen[3]">
            <div v-if="fee_currency === 'INR'">
              <CustomCheckbox v-for="(tuition_fee, index) in getTuitionFeesFilterValues" :title="tuition_fee.name"
                :id="index" :checked="filters.tuition_fees.includes(tuition_fee.value)"
                :key="'tuition_fee_filter_' + index" @checkbox-click="tuitionFeesSelected" />
            </div>
            <div v-if="fee_currency === 'USD'">
              <CustomCheckbox v-for="(
                  tuition_usd_fee, index
                ) in getTuitionUSDFeesFilterValues" :title="tuition_usd_fee.name" :id="index" :checked="filters.tuition_usd_fees.includes(tuition_usd_fee.value)
                  " :key="'tuition_usd_fee_filter_' + index" @checkbox-click="tuitionUSDFeesSelected" />
            </div>
            <!-- <CustomCheckbox
              v-for="(tuition_fee, index) in getTuitionFeesFilterValues"
              :title="tuition_fee.name"
              :id="index"
              :checked="filters.tuition_fees.includes(tuition_fee.value)"
              :key="'tuition_fee_filter_' + index"
              @checkbox-click="tuitionFeesSelected"
            /> -->
          </article>
        </section>
      </article>
      <!-- Filters Column End -->

      <article class="col-md-9 search-results-column">
        <label class="search-bar">
          <input type="text" autofocus v-model="filters.search_text" @input="getCourseListByFilter" />
          <img src="@/assets/imgs/svgs/search.svg" alt="" />
        </label>
        <p class="search-results">
          You found <span>{{ all_universities_count }} institutes</span> and
          <span>{{ all_courses_count }} courses</span>
        </p>

        <!-- <section class="search-filter-section d-flex">
          <div class="search-filter-dropdown" @click="showFilterMenu(1)">
            <label class="search-label-title">Level</label>
            <div class="d-block d-lg-none">
              <img src="@/assets/imgs/svgs/arrow-down.svg" alt="" />
            </div>
          </div>
          <article v-if="filtersOpen[1]" class="d-flex">
            <CustomCheckbox
              v-for="course_level in getCourseLevels"
              :title="course_level.course_level_name"
              :id="course_level.course_level_id"
              :checked="
                filters.course_level_ids.includes(course_level.course_level_id)
              "
              :key="'course_level_' + course_level.course_level_id"
              @checkbox-click="courseLevelSelected"
            />
          </article>
        </section> -->
        <div class="search-filter-section pr-1 mb-4">
          <div>
            <div class="d-flex justify-content-between bg-white align-items-center rounded" @click="() => {
                showAdvancedFilters = !showAdvancedFilters;
              }
              ">
              <h6 style="color: #000" class="m-0 p-3">Advanced Filters</h6>
              <div>

                <img src="@/assets/imgs/svgs/up-arrow.svg" alt="" class="pr-3" v-if="showAdvancedFilters" />
                <img src="@/assets/imgs/svgs/down-arrow.svg" alt="" class="pr-3" v-else />
              </div>
            </div>
          </div>
          <div class="" style="gap: 20px" v-if="showAdvancedFilters">
            <div class="search-filter-section d-flex align-items-center my-3" style="gap: 40px">
              <div class="search-label-title" @click="showFilterMenu(1)">
                <span class=""> Level </span>
              </div>
              <div class="search-checkbox-list d-flex align-items-center" v-if="filtersOpen[1]" style="gap: 40px">
                <CustomCheckbox v-for="course_level in getCourseLevels" :title="course_level.course_level_name"
                  :id="course_level.course_level_id" :checked="filters.course_level_ids.includes(
                    course_level.course_level_id
                  )
                    " :key="'course_level_' + course_level.course_level_id" @checkbox-click="courseLevelSelected" />
              </div>
            </div>
            <!-- Advance Filter Switches for aliff bitches -->
            <b-row style="margin-bottom: 2rem">
              <b-col>
                <multi-state-switch label="STEM" :options="tss_options" v-model="filters.stem_course"
                  @input="getCourseListByFilter" />
              </b-col>
              <b-col v-if="
                filters.course_level_names.some((el) =>
                  ['Master/PG', 'MBA'].includes(el)
                )
              ">
                <multi-state-switch label="15 Yrs Acceptable" :options="tss_options"
                  v-model="filters.fifteen_years_education_acceptable" @input="getCourseListByFilter" />
              </b-col>
              <b-col>
                <multi-state-switch label="IELTS Wavier" :options="tss_options" v-model="filters.ielts_wavier"
                  @input="getCourseListByFilter" />
              </b-col>
              <b-col v-if="
                filters.course_level_names.some((el) =>
                  ['Master/PG', 'MBA'].includes(el)
                )
              ">
                <multi-state-switch label="GRE REQUIRED" :options="tss_options" v-model="filters.gre_requirment"
                  @input="getCourseListByFilter" />
              </b-col>
              <b-col v-if="
                filters.course_level_names.some((el) =>
                  ['Diploma', 'Bachelor'].includes(el)
                )
              ">
                <multi-state-switch label="SAT REQUIRED" :options="tss_options" v-model="filters.sat_requirement"
                  @input="getCourseListByFilter" />
              </b-col>
              <div class="col">
                <button style="margin-top: 41px" class="clear-button mt-5 float-right" @click="clearAllFilters">
                  Clear All
                </button>
              </div>
            </b-row>
          </div>
        </div>

        <!-- ========== Filter and Sort Options ========== -->
        <section class="row mb-4 mb-lg-3">
          <!-- Filters -->
          <article class="col-xl-9 mb-3 mb-xl-0">
            <div class="d-flex">
              <span class="mb-2 text-nowrap" v-if="
                filters.country_names.length > 0 ||
                filters.city_names.length > 0 ||
                filters.course_level_names.length > 0 ||
                filters.course_category_names.length > 0 ||
                filters.tuition_fees_names.length > 0
              ">
                Filters :
              </span>
              <span class="ml-3 d-flex flex-wrap">
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.country_names" :key="index + 'SearchFilterLabel'"
                    :title="item" @cross-click="() => {
                        filters.country_names.splice(index, 1);
                        filters.country_ids.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.city_names" :key="index + 'city_names'"
                    :title="item" @cross-click="() => {
                        filters.city_names.splice(index, 1);
                        filters.city_ids.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.course_level_names"
                    :key="index + 'course_level_names'" :title="item" @cross-click="() => {
                        filters.course_level_names.splice(index, 1);
                        filters.course_level_ids.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.course_category_names"
                    :key="index + 'course_category_names'" :title="item" @cross-click="() => {
                        filters.course_category_names.splice(index, 1);
                        filters.course_category_ids.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.tuition_fees_names"
                    :key="index + 'tuition_fees_names'" :title="item" @cross-click="() => {
                        filters.tuition_fees_names.splice(index, 1);
                        filters.tuition_fees.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
                <div>
                  <SearchFilterLabel v-for="(item, index) in filters.tuition_usd_fees_names"
                    :key="index + 'tuition_usd_fees_names'" :title="item" @cross-click="() => {
                        filters.tuition_usd_fees_names.splice(index, 1);
                        filters.tuition_usd_fees.splice(index, 1);
                        getCourseListByFilter();
                      }
                      " />
                </div>
              </span>
            </div>
          </article>

          <!-- Sort By -->
          <article class="sort-filter col-xl-3">
            <b-dropdown variant="default" class="form-dropdown search-filter-dropdown">
              <template slot="button-content">
                <div class="dropdown-content">Sort By</div>
              </template>
              <b-dropdown-item @click="setOrderFilter('course_fee', 'desc')">Tuition fees (Low)
                <img src="@/assets/imgs/svgs/arrow-down-1.svg" alt="" />
              </b-dropdown-item>
              <b-dropdown-item @click="setOrderFilter('course_fee', 'asc')">Tuition fees (High)
                <img src="@/assets/imgs/svgs/arrow-up-1.svg" alt="" />
              </b-dropdown-item>
              <b-dropdown-item @click="setOrderFilter('application_fee', 'desc')">Application fees (Low)
                <img src="@/assets/imgs/svgs/arrow-down-1.svg" alt="" />
              </b-dropdown-item>
              <b-dropdown-item @click="setOrderFilter('application_fee', 'asc')">Application fees (High)
                <img src="@/assets/imgs/svgs/arrow-up-1.svg" alt="" />
              </b-dropdown-item>
            </b-dropdown>
          </article>
        </section>

        <div style="height: 100vh; overflow-y: scroll; scrollbar-width: none" v-infinite-scroll="onScroll"
          :infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <div v-if="coursesList.length > 0">
            <CourseProvider v-for="i in coursesList" :key="i.university_id" :item="i" />
          </div>
          <div v-else-if="courseLoading">
            <div class="text-center pulse">
              <b-spinner variant="primary" label="Loading..."></b-spinner>
              <p>Looking through our database for the best results</p>
            </div>
          </div>
          <div v-else-if="coursesList.length === 0">
            <div class="text-center pulse">
              <p>No results found</p>
            </div>
          </div>
        </div>
        <!-- <b-pagination
          v-model="pagination.currentPage"
          :total-rows="allCourseList.length"
          :per-page="pagination.perPage"
          aria-controls="my-table"
          align="right"
        ></b-pagination> -->
      </article>
    </section>
  </div>
</template>

<script>
import CustomCheckbox from "./helper/CustomCheckbox";
import SearchFilterLabel from "./helper/SearchFilterLabel.vue";
import CourseProvider from "./helper/CourseProvider.vue";
import HomeServices from "@/apiServices/homeServices";
import { mapGetters, mapActions } from "vuex";
import MultiStateSwitch from "@/components/extra/MultiStateSwitch.vue";
import infiniteScroll from "vue-infinite-scroll";

export default {
  name: "Search",
  components: {
    CustomCheckbox,
    SearchFilterLabel,
    CourseProvider,
    MultiStateSwitch,
  },
  data() {
    return {
      filtersOpen: [true, true, true, true],
      all_universities_count: 0,
      all_courses_count: 0,
      tss_options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Yes",
          value: "Y",
        },
        {
          label: "No",
          value: "N",
        },
      ],
      filters: {
        search_text: "",
        search_country: "",
        search_course_level: "",
        search_course_category: "",
        order_by: "",
        order: "",
        course_level_ids: [],
        course_level_names: [],
        course_category_ids: [],
        course_category_names: [],
        country_ids: [],
        city_ids: [],
        country_names: [],
        city_names: [],

        tuition_fees: [],
        tuition_fees_names: [],

        tuition_usd_fees: [],
        tuition_usd_fees_names: [],

        // Advance Filters
        stem_course: "",
        fifteen_years_education_acceptable: "",
        ielts_wavier: "",
        gre_requirment: "",
        sat_requirement: "",
      },
      courseLoading: false,
      coursesList: [],
      // allCourseList: [],
      pagination: {
        perPage: 30,
        currentPage: 1,
      },
      busy: false,

      // Debounce Search
      searchTimeout: null,

      fee_currency: "INR",
      showAdvancedFilters: false,
    };
  },
  watch: {
    // "pagination.currentPage": function (val) {
    //   this.coursesList = [];
    //   let temp_arr = [];
    //   for (
    //     let i = (val - 1) * 10;
    //     i < (val - 1) * 10 + this.pagination.perPage;
    //     i++
    //   ) {
    //     const course = this.allCourseList[i];
    //     temp_arr.push(course);
    //   }
    //   this.coursesList = temp_arr;
    // },
  },
  computed: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters([
      "getCountriesAndCities",
      "getCourseLevels",
      "getCourseCategories",
      "getTuitionFeesFilterValues",
      "getTuitionUSDFeesFilterValues",
    ]),
  },
  directives: { infiniteScroll },
  methods: {
    ...mapActions([
      "onGetCountriesAndCities",
      "onGetCourseLevels",
      "onGetCourseCategories",
      "onGetTuitionFeesFilterValues",
      "onGetTuitionUSDFeesFilterValues",
    ]),
    showFilterMenu(index) {
      if (this.isMobile) {
        this.$set(this.filtersOpen, index, !this.filtersOpen[index]);
      }
    },
    setOrderFilter(order_by, order) {
      this.filters.order_by = order_by;
      this.filters.order = order;
      this.getCourseListByFilter();
    },
    courseLevelSelected(id, name) {
      if (this.filters.course_level_ids.includes(id)) {
        this.filters.course_level_ids.splice(
          this.filters.course_level_ids.indexOf(id),
          1
        );
        this.filters.course_level_names.splice(
          this.filters.course_level_names.indexOf(name),
          1
        );
      } else {
        this.filters.course_level_ids.push(id);
        this.filters.course_level_names.push(name);
      }
      this.getCourseListByFilter();
    },
    courseCategorySelected(id, name) {
      if (this.filters.course_category_ids.includes(id)) {
        this.filters.course_category_ids.splice(
          this.filters.course_category_ids.indexOf(id),
          1
        );
        this.filters.course_category_names.splice(
          this.filters.course_category_names.indexOf(name),
          1
        );
      } else {
        this.filters.course_category_ids.push(id);
        this.filters.course_category_names.push(name);
      }
      this.getCourseListByFilter();
    },
    countrySelected(id, name) {
      if (this.filters.country_ids.includes(id)) {
        this.filters.country_ids.splice(
          this.filters.country_ids.indexOf(id),
          1
        );
        this.filters.country_names.splice(
          this.filters.country_names.indexOf(name),
          1
        );
      } else {
        this.filters.country_ids.push(id);
        this.filters.country_names.push(name);
      }
      this.getCourseListByFilter();
    },
    citySelected(id, name) {
      if (this.filters.city_ids.includes(id)) {
        this.filters.city_ids.splice(this.filters.city_ids.indexOf(id), 1);
        this.filters.city_names.splice(
          this.filters.city_names.indexOf(name),
          1
        );
      } else {
        this.filters.city_ids.push(id);
        this.filters.city_names.push(name);
      }
      this.getCourseListByFilter();
    },
    clearTuitionFee() {
      if (
        this.filters.tuition_usd_fees.length ||
        this.filters.tuition_fees.length
      ) {
        setTimeout(() => {
          this.getCourseListByFilter();
        });
      }

      this.filters.tuition_usd_fees = [];
      this.filters.tuition_usd_fees_names = [];
      this.filters.tuition_fees = [];
      this.filters.tuition_fees_names = [];
    },
    tuitionFeesSelected(index, name) {
      if (
        JSON.stringify(this.filters.tuition_fees) ===
        JSON.stringify([this.getTuitionFeesFilterValues[index].value])
      ) {
        this.filters.tuition_fees = [];
        this.filters.tuition_fees_names = [];
      } else {
        this.filters.tuition_fees = [
          this.getTuitionFeesFilterValues[index].value,
        ];
        this.filters.tuition_fees_names = [name];
      }
      this.getCourseListByFilter();
    },
    tuitionUSDFeesSelected(index, name) {
      if (
        JSON.stringify(this.filters.tuition_usd_fees) ===
        JSON.stringify([this.getTuitionUSDFeesFilterValues[index].value])
      ) {
        this.filters.tuition_usd_fees = [];
        this.filters.tuition_usd_fees_names = [];
      } else {
        this.filters.tuition_usd_fees = [
          this.getTuitionUSDFeesFilterValues[index].value,
        ];
        this.filters.tuition_usd_fees_names = [name];
      }
      this.getCourseListByFilter();
    },

    getCourseListByFilter() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        console.log('getCourseListByFilter');
        this.pagination.currentPage = 1;
        this.coursesList = [];
        this.getCourseList({
          searchText: this.filters.search_text,
          order_by: this.filters.order_by,
          order: this.filters.order,
          country_ids: this.filters.country_ids.toString(),
          city_ids: this.filters.city_ids.toString(),
          course_level_ids: this.filters.course_level_ids.toString(),
          course_category_ids: this.filters.course_category_ids.toString(),
          tuition_fees: this.filters.tuition_fees[0],
          tuition_usd_fees: this.filters.tuition_usd_fees[0],

          // Advance Filters
          stem_course: this.filters.stem_course,
          fifteen_years_education_acceptable:
            this.filters.fifteen_years_education_acceptable,
          ielts_wavier: this.filters.ielts_wavier,
          gre_requirment: this.filters.gre_requirment,
          sat_requirement: this.filters.sat_requirement,
        });
      }, 1000);
    },
    async getCourseList(payload = {}) {
      const getCoursesLoader = this.$loading.show();
      this.courseLoading = true;
      payload = {
        ...payload,
        currentPage: this.pagination.currentPage,
        perPage: this.pagination.perPage,
      };
      await HomeServices.getCourseList(payload)
        .then((response) => {
          if (!response.data.status) return;
          localStorage.setItem("search_filters", JSON.stringify(this.filters));
          const course_arr = response.data.data.data;
          this.all_universities_count =
            response.data.data.all_universities_count;
          this.all_courses_count = response.data.data.all_courses_count;

          if (this.pagination.currentPage === 1) {
            this.coursesList = course_arr;
          } else {
            const uniList = JSON.parse(JSON.stringify(this.coursesList));
            this.coursesList = [];
            this.$nextTick(() => {
              this.coursesList = uniList.concat(course_arr);
            });
          }
        })
        .catch((err) => {
          console.log("Error getting Course List ", err);
        })
        .finally(() => {
          this.courseLoading = false;
          getCoursesLoader.hide();
        });
    },
    async onScroll() {
      // alert("onScroll");

      this.busy = true;

      console.log(
        `${this.coursesList.length} >= ${this.all_universities_count}`
      );
      if (this.coursesList.length >= this.all_universities_count) {
        return;
      }
      this.pagination.currentPage = this.pagination.currentPage + 1;

      await this.getCourseList({
        searchText: this.filters.search_text,
        order_by: this.filters.order_by,
        order: this.filters.order,
        country_ids: this.filters.country_ids.toString(),
        city_ids: this.filters.city_ids.toString(),
        course_level_ids: this.filters.course_level_ids.toString(),
        course_category_ids: this.filters.course_category_ids.toString(),
        tuition_fees: this.filters.tuition_fees[0],
        tuition_usd_fees: this.filters.tuition_usd_fees[0],

        // Advance Filters
        stem_course: this.filters.stem_course,
        fifteen_years_education_acceptable:
          this.filters.fifteen_years_education_acceptable,
        ielts_wavier: this.filters.ielts_wavier,
        gre_requirment: this.filters.gre_requirment,
        sat_requirement: this.filters.sat_requirement,
      });
      this.busy = false;
    },
    setFiltersAndGetCourseList() {
      if (window.courseFilter) {
        if (window.courseFilter.searchText) {
          this.filters.search_text = window.courseFilter.searchText;
        }
        if (window.courseFilter.country) {
          this.filters.country_ids = [window.courseFilter.country.id];
          this.filters.country_names = [window.courseFilter.country.name];
        }
        if (window.courseFilter.course_level) {
          this.filters.course_level_ids = [window.courseFilter.course_level.id];
          this.filters.course_level_names = [
            window.courseFilter.course_level.name,
          ];
        }
        if (window.courseFilter.course_category) {
          this.filters.course_category_ids = [
            window.courseFilter.course_category.id,
          ];
          this.filters.course_category_names = [
            window.courseFilter.course_category.name,
          ];
        }

        this.getCourseListByFilter();
        window.courseFilter = null;
      } else {
        const filters = localStorage.getItem("search_filters");
        if (filters) {
          this.filters = {
            ...this.filters,
            ...JSON.parse(filters),
          };
          this.getCourseListByFilter();
        } else {
          this.getCourseList();
        }
      }
    },
    clearAllFilters() {
      this.filters = {
        search_text: "",
        search_country: "",
        search_course_level: "",
        search_course_category: "",
        order_by: "",
        order: "",
        course_level_ids: [],
        course_level_names: [],
        course_category_ids: [],
        course_category_names: [],
        country_ids: [],
        city_ids: [],
        country_names: [],
        city_names: [],
        tuition_fees: [],
        tuition_fees_names: [],
        tuition_usd_fees: [],
        tuition_usd_fees_names: [],

        stem_course: "",
        fifteen_years_education_acceptable: "",
        ielts_wavier: "",
        gre_requirment: "",
        sat_requirement: "",
      };
      this.getCourseListByFilter();
    },
  },
  beforeMount() {
    this.onGetCountriesAndCities();
    this.onGetCourseLevels();
    this.onGetCourseCategories();
    this.onGetTuitionFeesFilterValues();
    this.onGetTuitionUSDFeesFilterValues();
    if (this.isMobile) {
      this.filtersOpen = [false, false, false, false];
    }
    const { search } = this.$route.params;
    if (search && search !== "search") {
      this.filters.search_text = search;
      this.getCourseListByFilter();
    } else {
      this.setFiltersAndGetCourseList();
    }
  },
};
</script>

<style>
.custom-checkbox .custom-control-input,
.custom-radio .custom-control-input {
  width: 1.285rem;
  height: 1.285rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  width: 1rem;
  height: 1.225rem;
  opacity: 0;
}

.custom-control-input:checked~.custom-control-label::before {
  border-color: #5367ff;
  background-color: #5367ff !important;
}

[dir="ltr"] .custom-checkbox .custom-control-label::before,
[dir="ltr"] .custom-checkbox .custom-control-label::after,
[dir="ltr"] .custom-radio .custom-control-label::before,
[dir="ltr"] .custom-radio .custom-control-label::after {
  left: 0;
}

[dir] .custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-image: none;
}

.clear-button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 9999px;
  padding: 8px 20px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.clear-button:hover {
  background-color: white;
  color: #007bff;
  border: 1px solid #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Search/Search.vue